/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'serial': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<g _fill="#C4FFF9" fill-rule="nonzero"><path pid="0" d="M41.18 46.262h5.508v55.508H41.18zM50.816 46.262h5.508v45.809h-5.508zM58.387 46.262h5.508v45.809h-5.508zM68.027 46.262h2.754v45.809h-2.754zM74.91 46.262h2.754v45.809H74.91zM81.793 46.262h7.574v45.809h-7.574zM95.562 46.262h6.883v45.809h-6.883zM105.887 46.262h2.754v55.508h-2.754z"/><path pid="1" d="M112.102 34.387H38.204c-5.035 0-9.133 4.097-9.133 9.132v62.81c0 5.035 4.098 9.132 9.133 9.132h73.898c5.035 0 9.133-4.097 9.133-9.132V43.517c0-5.036-4.098-9.13-9.133-9.13zm5.137 71.94a5.143 5.143 0 0 1-5.137 5.137H38.204a5.143 5.143 0 0 1-5.137-5.136V43.516a5.143 5.143 0 0 1 5.137-5.137h73.898a5.143 5.143 0 0 1 5.137 5.137v62.812z"/></g>'
  }
})
